<script lang="ts" module>
  import { User, Building } from "lucide-svelte"
  export { present_user, present_department, present_status }
</script>

{#snippet present_user(item: FilterType)}
  <div class="inline-flex items-center">
    <User class="w-3.5 inline icon-img" />
    {item.label}
  </div>
{/snippet}

{#snippet present_department(item: FilterType)}
  <div class="inline-flex items-center">
    <Building class="w-3.5 inline icon-img" />
    {item.label}
  </div>
{/snippet}

{#snippet present_status(item: FilterType)}
  <div class="inline-flex items-center">
    <div
      class="flex-none inline-block size-4 rounded-full bg-{item.value}"
    ></div>
    {item.label}
  </div>
{/snippet}
